// Numeric SEC code → ISO code mapping, for backward compatibility with old DB records
export const FORMPF_NUMERIC_TO_ISO = [
  { value: '001', label: 'USD' },
  { value: '002', label: 'AFN' },
  { value: '003', label: 'ALL' },
  { value: '004', label: 'DZD' },
  { value: '005', label: 'ADP' },
  { value: '006', label: 'AOA' },
  { value: '007', label: 'XCD' },
  { value: '008', label: 'AUD' },
  { value: '009', label: 'ARS' },
  { value: '010', label: 'AMD' },
  { value: '011', label: 'AWG' },
  { value: '012', label: 'AUD' },
  { value: '013', label: 'ATS' },
  { value: '014', label: 'AZN' },
  { value: '015', label: 'BSD' },
  { value: '016', label: 'BHD' },
  { value: '017', label: 'BDT' },
  { value: '018', label: 'BBD' },
  { value: '019', label: 'BYN' },
  { value: '020', label: 'BEF' },
  { value: '021', label: 'BZD' },
  { value: '022', label: 'XOF' },
  { value: '023', label: 'BMD' },
  { value: '024', label: 'BTN' },
  { value: '025', label: 'BOB' },
  { value: '026', label: 'BAM' },
  { value: '027', label: 'BWP' },
  { value: '028', label: 'BRL' },
  { value: '029', label: 'GBP' },
  { value: '030', label: 'GBP' },
  { value: '031', label: 'BND' },
  { value: '032', label: 'BGN' },
  { value: '033', label: 'XOF' },
  { value: '034', label: 'BIF' },
  { value: '035', label: 'KHR' },
  { value: '036', label: 'XAF' },
  { value: '037', label: 'CAD' },
  { value: '038', label: 'EUR' },
  { value: '039', label: 'GBP' },
  { value: '040', label: 'CVE' },
  { value: '041', label: 'KYD' },
  { value: '042', label: 'XAF' },
  { value: '043', label: 'XOF' },
  { value: '044', label: 'XAF' },
  { value: '045', label: 'XAF' },
  { value: '046', label: 'CLP' },
  { value: '047', label: 'CNY' },
  { value: '048', label: 'AUD' },
  { value: '049', label: 'AUD' },
  { value: '050', label: 'COP' },
  { value: '051', label: 'KMF' },
  { value: '052', label: 'XAF' },
  { value: '053', label: 'CDF' },
  { value: '054', label: 'NZD' },
  { value: '055', label: 'CRC' },
  { value: '056', label: 'HRK' },
  { value: '057', label: 'CUP' },
  { value: '058', label: 'CYP' },
  { value: '059', label: 'CZK' },
  { value: '060', label: 'DKK' },
  { value: '061', label: 'DJF' },
  { value: '062', label: 'XCD' },
  { value: '063', label: 'DOP' },
  { value: '064', label: 'XCD' },
  { value: '065', label: 'USD' },
  { value: '066', label: 'ECS' },
  { value: '067', label: 'EGP' },
  { value: '068', label: 'SVC' },
  { value: '069', label: 'XAF' },
  { value: '070', label: 'ERN' },
  { value: '071', label: 'EEK' },
  { value: '072', label: 'ETB' },
  { value: '073', label: 'EUR' },
  { value: '074', label: 'FKP' },
  { value: '075', label: 'DKK' },
  { value: '076', label: 'FJD' },
  { value: '077', label: 'FIM' },
  { value: '078', label: 'FRF' },
  { value: '079', label: 'EUR' },
  { value: '080', label: 'XPF' },
  { value: '081', label: 'XAF' },
  { value: '082', label: 'GMD' },
  { value: '083', label: 'GEL' },
  { value: '084', label: 'DEM' },
  { value: '085', label: 'GIP' },
  { value: '086', label: 'GRD' },
  { value: '087', label: 'DKK' },
  { value: '088', label: 'XCD' },
  { value: '089', label: 'EUR' },
  { value: '090', label: 'USD' },
  { value: '091', label: 'GTQ' },
  { value: '092', label: 'GGP' },
  { value: '093', label: 'XOF' },
  { value: '094', label: 'GNF' },
  { value: '095', label: 'GYD' },
  { value: '096', label: 'HTG' },
  { value: '097', label: 'HNL' },
  { value: '098', label: 'HKD' },
  { value: '099', label: 'HUF' },
  { value: '100', label: 'ISK' },
  { value: '101', label: 'INR' },
  { value: '102', label: 'IDR' },
  { value: '103', label: 'IRR' },
  { value: '104', label: 'IQD' },
  { value: '105', label: 'IEP' },
  { value: '106', label: 'IMP' },
  { value: '107', label: 'ILS' },
  { value: '108', label: 'ITL' },
  { value: '109', label: 'XOF' },
  { value: '110', label: 'JMD' },
  { value: '111', label: 'JPY' },
  { value: '112', label: 'JEP' },
  { value: '113', label: 'USD' },
  { value: '114', label: 'JOD' },
  { value: '115', label: 'KZT' },
  { value: '116', label: 'KES' },
  { value: '117', label: 'AUD' },
  { value: '118', label: 'KWD' },
  { value: '119', label: 'KGS' },
  { value: '120', label: 'LAK' },
  { value: '121', label: 'LVL' },
  { value: '122', label: 'LBP' },
  { value: '123', label: 'LSL' },
  { value: '124', label: 'LRD' },
  { value: '125', label: 'LYD' },
  { value: '126', label: 'CHF' },
  { value: '127', label: 'LTL' },
  { value: '128', label: 'LUF' },
  { value: '129', label: 'MOP' },
  { value: '130', label: 'MKD' },
  { value: '131', label: 'MGA' },
  { value: '132', label: 'MWK' },
  { value: '133', label: 'MYR' },
  { value: '134', label: 'MVR' },
  { value: '135', label: 'XOF' },
  { value: '136', label: 'MTL' },
  { value: '137', label: 'EUR' },
  { value: '138', label: 'MRU' },
  { value: '139', label: 'MUR' },
  { value: '140', label: 'EUR' },
  { value: '141', label: 'MXN' },
  { value: '142', label: 'USD' },
  { value: '143', label: 'USD' },
  { value: '144', label: 'MDL' },
  { value: '145', label: 'EUR' },
  { value: '146', label: 'MNT' },
  { value: '147', label: 'EUR' },
  { value: '148', label: 'XCD' },
  { value: '149', label: 'MAD' },
  { value: '150', label: 'MZN' },
  { value: '151', label: 'MMK' },
  { value: '152', label: 'NAD' },
  { value: '153', label: 'AUD' },
  { value: '154', label: 'NPR' },
  { value: '155', label: 'NLG' },
  { value: '156', label: 'ANG' },
  { value: '157', label: 'GHS' },
  { value: '158', label: 'SDG' },
  { value: '159', label: 'NZD' },
  { value: '160', label: 'NIO' },
  { value: '161', label: 'XOF' },
  { value: '162', label: 'NGN' },
  { value: '163', label: 'NZD' },
  { value: '164', label: 'AUD' },
  { value: '165', label: 'KPW' },
  { value: '166', label: 'USD' },
  { value: '167', label: 'NOK' },
  { value: '168', label: 'CNH' },
  { value: '169', label: 'OMR' },
  { value: '170', label: 'PKR' },
  { value: '171', label: 'USD' },
  { value: '172', label: 'PAB' },
  { value: '173', label: 'PGK' },
  { value: '174', label: 'PYG' },
  { value: '175', label: 'PEN' },
  { value: '176', label: 'PHP' },
  { value: '177', label: 'NZD' },
  { value: '178', label: 'PLN' },
  { value: '179', label: 'PTE' },
  { value: '180', label: 'USD' },
  { value: '181', label: 'QAR' },
  { value: '182', label: 'RON' },
  { value: '183', label: 'RUB' },
  { value: '184', label: 'RWF' },
  { value: '185', label: 'EUR' },
  { value: '186', label: 'EUR' },
  { value: '187', label: 'STN' },
  { value: '188', label: 'SAR' },
  { value: '189', label: 'XOF' },
  { value: '190', label: 'RSD' },
  { value: '191', label: 'SCR' },
  { value: '192', label: 'SLL' },
  { value: '193', label: 'SGD' },
  { value: '194', label: 'SKK' },
  { value: '195', label: 'SIT' },
  { value: '196', label: 'SBD' },
  { value: '197', label: 'SOS' },
  { value: '198', label: 'ZAR' },
  { value: '199', label: 'KRW' },
  { value: '200', label: 'ESP' },
  { value: '201', label: 'LKR' },
  { value: '202', label: 'SHP' },
  { value: '203', label: 'XCD' },
  { value: '204', label: 'XCD' },
  { value: '205', label: 'XCD' },
  { value: '206', label: 'SDG' },
  { value: '207', label: 'SRD' },
  { value: '208', label: 'SZL' },
  { value: '209', label: 'SEK' },
  { value: '210', label: 'CHF' },
  { value: '211', label: 'SYP' },
  { value: '212', label: 'TWD' },
  { value: '213', label: 'TJS' },
  { value: '214', label: 'TZS' },
  { value: '215', label: 'THB' },
  { value: '216', label: 'THB' },
  { value: '217', label: 'XOF' },
  { value: '218', label: 'NZD' },
  { value: '219', label: 'TOP' },
  { value: '220', label: 'TTD' },
  { value: '221', label: 'TND' },
  { value: '222', label: 'TRY' },
  { value: '223', label: 'TRL' },
  { value: '224', label: 'TMT' },
  { value: '225', label: 'USD' },
  { value: '226', label: 'AUD' },
  { value: '227', label: 'AED' },
  { value: '228', label: 'UGX' },
  { value: '229', label: 'UAH' },
  { value: '230', label: 'UYU' },
  { value: '231', label: 'UZS' },
  { value: '232', label: 'VUV' },
  { value: '233', label: 'EUR' },
  { value: '234', label: 'VES' },
  { value: '235', label: 'VES' },
  { value: '236', label: 'VND' },
  { value: '237', label: 'WST' },
  { value: '238', label: 'YER' },
  { value: '239', label: 'ZMW' },
  { value: '240', label: 'ZWL' },
  { value: '999', label: 'XXX' }
];
